import React from 'react';

import MemoryFilesGridItem from './FilesGridItem';

import type { Asset } from '../../types/asset';

interface MemoryFilesGridProps {
  files: Asset[];
  variant?: 'memory' | 'sprk';
  handleAddFile: () => void;
  handleRemoveFile: (fileId: string) => void;
};

const MemoryFilesGrid: React.FC<MemoryFilesGridProps> = ({ files, variant, handleAddFile, handleRemoveFile }) => {
  return (
    <div className="memory-files-grid">
      {files.filter(f => (!f.shared)).map((file) => (
        <MemoryFilesGridItem key={file.id} file={file} handleRemoveFile={handleRemoveFile} />
      ))}
      {(files.length < 25 && variant === 'memory') && (
        <div className="memory-files-grid-item memory-files-grid-add-file" onClick={handleAddFile}>
          <i className="fas fa-plus"></i>
        </div>
      )}
    </div>
  );
}

export default MemoryFilesGrid;
